import { AxiosResponse } from 'axios'
import { axiosInstance } from '~/src/config/config_axios'
import { IDashBoardResponse } from './models/DashBoard'

export class DashBoardRepository {
  async getDashboardItem(): Promise<AxiosResponse<IDashBoardResponse['data']>> {
    return axiosInstance.get('/dashboard')
  }
}
